import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { GaritaService } from '../../services/garita/garita.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { medicinaModulo } from '../../diccionarios/medicinaModulo';


@Component({
  selector: 'app-seguridad',
  templateUrl: './seguridad.component.html',
  styleUrls: ['./seguridad.component.css']
})
export class SeguridadComponent implements OnInit {

  check: HTMLInputElement;
  formulario: FormGroup;
  Bloqueado = false;
  desbloqueado = false;

  loading = false;

  imagen: string;
  mostrarMensaje: string;
  status: string;

  ingresoPlant: string = '';

  diccionarioModulo: any = {};
  ruta = '';
  // ruta = '../../../fabmedical/assets/image/estados/';

  cmbPuerta : any[];
  cmbArea   : any[];

  selectedDoor: any = {};


  horario:string = " NO SELECIONADO";
  estadoHorario:string = "";
  estilo:string = "text-dark";
  estiloBtn:string = "btn-success";
  lastEstiloBtn:string = "btn-success";
  strTermCond: string = '';
  opcionTermCond: string = 'No';
  valueTermCond: number = 0;
  activated:boolean = false;

  nombreColaborador: string;
  numeroDias: string;
  msnDias: string;
  mostrarDias = false;
  numeroMeses: string;
  msnDias_: string;
  msnDias__: string;
  colorLetrasDanger = false;

  constructor(private fb: FormBuilder,
    private servicioWeb: GaritaService,
    private utilsServicio: UtilsService) { }

  ngOnInit() {
    this.diccionarioModulo = medicinaModulo;
    //this.ruta = this.diccionarioModulo.url.srcImagenes.estados;
    this.ruta = "assets/images/estados/";

    this.formulario = this.fb.group({
      tarjeta: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
      idArea:[''],
      idPuerta:[''],
      termCond:['']
    });
    this.checking();
    this.cargarAreas();
  }

  cargarAreas(){
    this.servicioWeb.getListaAreas().subscribe((resp) => {
      console.log(resp);
      this.cmbArea = resp.respuesta;
    });
  }

  selecionarArea(){
    this.servicioWeb.getListaPuerta(this.formulario.get("idArea").value).subscribe( (resp) =>{
      console.log(resp);
      this.cmbPuerta = resp.respuesta;
    });
    
  }

  selecionarPuerta(){
    console.log(this.formulario.get("idPuerta").value);
    this.selectedDoor = this.cmbPuerta.find( element => {return element.priIP === this.formulario.get("idPuerta").value;} );
    console.log(this.selectedDoor);
  }

  enviarTarjeta(innDato) {
    if(this.activated === true){
      if(this.horario === ' NO SELECIONADO'){
        this.utilsServicio.mensajeErrorVisto("No ha selecionado el control de acceso", true, 9000);
        return;
      }else if (this.formulario.get("idPuerta").value === "" || this.formulario.get("idPuerta").value === undefined){
        this.utilsServicio.mensajeErrorVisto("No ha selecionado la Puerta", true, 9000);
        return;
      }
    }

    this.status = '';
    if (innDato === '') {
      innDato = this.formulario.get('tarjeta').value;
    }
    this.loading = true;
    this.mostrarDias = false;
    this.nombreColaborador = '';
    this.msnDias = '';
    this.msnDias_ = '';
    this.msnDias__ = '';
    this.colorLetrasDanger = false;
    this.servicioWeb.getTarjeta(
        innDato,
        this.formulario.get("idPuerta").value,
        this.horario,
        this.activated === true ? 1 : 0
                        ).subscribe((resp) => {

      this.mensajesStatus(resp);
      this.mostrarMensaje = resp.mensaje;
      this.status = resp.status;
      this.formulario.get('tarjeta').setValue('');
      this.loading = false;

      this.nombreColaborador = resp.respuesta.nombreColaborador;
      this.numeroDias = resp.respuesta.numeroDias;
      this.numeroMeses = resp.respuesta.numeroMeses;
      if (resp.status === "InmunePrimerDosis") {
        this.mostrarMensaje = 'COLABORADOR INMUNE 1ERA DOSIS VACUNADO';
        return;
      } else if (resp.status === "InmuneSegundaDosis") {
        this.mostrarMensaje = 'COLABORADOR INMUNE 2DA DOSIS VACUNADO';
        return;
      } else if (resp.status === "InmuneTerceraDosis") {
        this.mostrarMensaje = 'COLABORADOR INMUNE 3ERA DOSIS VACUNADO';
        return;
      }
      let meses = (Math.abs(Number(this.numeroMeses))) > 1 ? 'meses' : 'mes';
      let dias = (Math.abs(Number(this.numeroDias))) > 1 ? 'dias' : 'dia';
      if (this.numeroDias != '' || this.numeroMeses != '') {
        this.mostrarDias = true;
        if ((this.numeroMeses != '' && this.numeroMeses != '0' && this.numeroDias != '' && this.numeroDias != '0')) {
          let dia = Math.sign(Number(this.numeroDias))
          if (dia == -1) {
            this.msnDias = `Tu prueba fue hace ${Math.abs(Number(this.numeroMeses))} ${meses} y ${Math.abs(Number(this.numeroDias))} ${dias}!`;
          }
          else {
            this.msnDias = `Proxima prueba en ${Math.abs(Number(this.numeroMeses))} ${meses} y ${Math.abs(Number(this.numeroDias))} ${dias}!`;
          }
        } else {
          if ((this.numeroMeses == '' || this.numeroMeses == '0') && this.numeroDias != '') {
            let dia = Math.sign(Number(this.numeroDias))
            if (dia == -1) {
              if (Math.abs(Number(this.numeroDias)) == 1) {
                this.msnDias_ = 'Serás bloquedado en 1 día';
                this.msnDias__ = 'Realice su prueba';
                this.colorLetrasDanger = true;
              } else if (Math.abs(Number(this.numeroDias)) == 2) {
                this.msnDias_ = 'Serás bloquedado mañana';
                this.msnDias__ = 'Realice su prueba';
                this.colorLetrasDanger = true;
              }
              this.msnDias = `Tu prueba fue hace ${Math.abs(Number(this.numeroDias))} ${dias}!`;
            } else if (dia == 0) {
              this.msnDias = `Tu prueba es hoy ${resp.respuesta.programValoracion}`;
              this.msnDias_ = 'Serás bloquedado en 2 días';
              this.msnDias__ = 'Realice su prueba';
              this.colorLetrasDanger = false;
            } else {
              this.msnDias = `Proxima prueba en ${Math.abs(Number(this.numeroDias))} ${dias}!`;
            }
          } else {
            let mes = Math.sign(Number(this.numeroMeses))
            if (mes == -1) {
              this.msnDias = `Tu prueba fue hace ${Math.abs(Number(this.numeroMeses))} ${meses}!`;
            }
            else {
              this.msnDias = `Proxima prueba en ${Math.abs(Number(this.numeroMeses))} ${meses}!`;
            }
          }
        }
      } else {
        this.mostrarDias = false;
      }

    }, (error) => {
      this.loading = false;
      this.mostrarBloqueado();
      this.mensajesStatus(error.error);
      this.utilsServicio.mensajeErrorVisto(error.error.mensaje, true, 1200);
      this.formulario.get('tarjeta').setValue('');
      this.mostrarMensaje = error.error.mensaje;
      // debugger
      this.nombreColaborador = error.error.respuesta.nombreColaborador;
      this.numeroDias = error.error.respuesta.numeroDias;
      this.numeroMeses = error.error.respuesta.numeroMeses;
      let meses = (Math.abs(Number(this.numeroMeses))) > 1 ? 'meses' : 'mes';
      let dias = (Math.abs(Number(this.numeroDias))) > 1 ? 'dias' : 'dia';
      if (this.numeroDias != '' || this.numeroMeses != '') {
        this.mostrarDias = true;
        if ((this.numeroMeses != '' && this.numeroMeses != '0' && this.numeroDias != '' && this.numeroDias != '0')) {
          let dia = Math.sign(Number(this.numeroDias))
          if (dia == -1) {
            this.msnDias = `Tu prueba fue hace ${Math.abs(Number(this.numeroMeses))} ${meses} y ${Math.abs(Number(this.numeroDias))} ${dias}!`;
          }
          else {
            this.msnDias = `Proxima prueba en ${Math.abs(Number(this.numeroMeses))} ${meses} y ${Math.abs(Number(this.numeroDias))} ${dias}!`;
          }
        } else {
          if ((this.numeroMeses == '' || this.numeroMeses == '0') && this.numeroDias != '') {
            let dia = Math.sign(Number(this.numeroDias))
            if (dia == -1) {
              if (Math.abs(Number(this.numeroDias)) == 1) {
                this.msnDias_ = 'Serás bloquedado en 1 día';
                this.msnDias__ = 'Realice su prueba';
                this.colorLetrasDanger = true;
              } else if (Math.abs(Number(this.numeroDias)) == 2) {
                this.msnDias_ = 'Serás bloquedado mañana';
                this.msnDias__ = 'Realice su prueba';
                this.colorLetrasDanger = true;
              }
              this.msnDias = `Tu prueba fue hace ${Math.abs(Number(this.numeroDias))} ${dias}!`;
            } else if (dia == 0) {
              this.msnDias = `Tu prueba es hoy ${error.error.respuesta.programValoracion}`;
              this.msnDias_ = 'Serás bloquedado en 2 días';
              this.msnDias__ = 'Realice su prueba';
              this.colorLetrasDanger = false;
            } else {
              this.msnDias = `Proxima prueba en ${Math.abs(Number(this.numeroDias))} ${dias}!`;
            }
          }
        }
      } else {
        this.mostrarDias = false;
      }
    });
  }

  onKeydown(event) {
    console.log(this.formulario.get('tarjeta').value);
    if ((event.key === 'Enter' || this.formulario.valid === true)) {
      this.enviarTarjeta(this.formulario.get('tarjeta').value);
    }
  }

  mostarActivo() {
    this.Bloqueado = false;
    this.desbloqueado = true;
  }

  mostrarBloqueado() {
    this.desbloqueado = false;
    this.Bloqueado = true;
  }

  mensajesStatus(data) {
    // debugger
    this.ingresoPlant = 'SI PUEDE ENTRAR A LA PLANTA - ';
    this.imagen = '';
    switch (data.status) {
      case 'Activo':
        this.mostarActivo();
        this.imagen = this.ruta + 'entrarOK.jpg'
        this.utilsServicio.mensajeOKVisto(data.mensaje, true, 1200);
        break;
      case 'DesbloqueoTOTAL':
        this.mostarActivo();
        this.imagen = this.ruta + 'desbloqueofull.jpg'
        this.utilsServicio.mensajeOKVisto(data.mensaje, true, 1200);
        break;
      case 'Valoracion':
        this.mostrarBloqueado();
        this.imagen = this.ruta + 'valoracionfull.png'
        this.utilsServicio.mensajeErrorVisto(data.mensaje, true, 1200);
        break;
      case 'ValoracionTELEMEDICINA':
        this.mostrarBloqueado();
        this.imagen = this.ruta + 'cuarentena1.png'
        this.utilsServicio.mensajeErrorVisto(data.mensaje, true, 1200);
        break;
      case 'Cuarentena':
        this.mostrarBloqueado();
        this.imagen = this.ruta + 'cuarentenafull.png'
        this.utilsServicio.mensajeErrorVisto(data.mensaje, true, 1200);
        break;
      case 'Bloqueado':
        this.mostrarBloqueado();
        this.imagen = this.ruta + 'bloqueadofull.png'
        this.utilsServicio.mensajeErrorVisto(data.mensaje, true, 1200);
        break;
      case 'PermisoMedico':
        this.mostrarBloqueado();
        this.imagen = this.ruta + 'permisoMedico.png'
        this.utilsServicio.mensajeErrorVisto(data.mensaje, true, 1200);
        break;
      case 'ErrorTarjeta':
        this.imagen = this.ruta + 'errorTarjeta.png'
        this.status = 'ERROR EN LA TARJETA';
        break;
      case 'ErrorNDatos':
        this.imagen = this.ruta + 'noEntrar.png'
        this.status = 'SIN INFORMACION EN TELEMEDICINA';
        break;
      case 'BloquadoPorData':
        this.mostarActivo();
        this.imagen = this.ruta + 'entrarOK.jpg'
        this.status = 'SIN INFORMACION EN TELEMEDICINA';
        break;
      case 'ConSintoma':
        this.mostarActivo();
        this.ingresoPlant = "";
        this.imagen = this.ruta + 'permisoMedico.png'
        this.status = 'CON SINTIMAS';
        break;
      case 'Desvinculado':
        // debugger
        this.imagen = this.ruta + 'noEntrar.png'
        this.status = 'COLABORADOR DESVINCULADO';
        break;
      case 'InmunePrimerDosis':
        this.mostarActivo();
        let msnStr = 'COLABORADOR INMUNE 1ERA DOSIS VACUNADO';
        this.imagen = this.ruta + 'entrarOK.jpg'
        this.utilsServicio.mensajeOKVisto(msnStr, true, 1200);
        break;
      case 'InmuneSegundaDosis':
        this.mostarActivo();
        let msnStr2 = 'COLABORADOR INMUNE 2DA DOSIS VACUNADO';
        this.imagen = this.ruta + 'entrarOK.jpg'
        this.utilsServicio.mensajeOKVisto(msnStr2, true, 1200);
        break;
      case 'InmuneTerceraDosis':
        this.mostarActivo();
        let msnStr3 = 'COLABORADOR INMUNE 3DA DOSIS VACUNADO';
        this.imagen = this.ruta + 'entrarOK.jpg'
        this.utilsServicio.mensajeOKVisto(msnStr3, true, 1200);
        break;
      case 'TerminoCondicion':
        this.mostrarBloqueado();
        this.imagen = this.ruta + 'noEntrar.png'
        break;
      case 'AdeccoIESS':
        this.mostrarBloqueado();
        this.imagen = this.ruta + 'noEntrar.png'
        break;
      case 'Error':
        this.imagen = this.ruta + 'noEntrar.png';
        break;  
      default:
        break;
    }
  }

  ejecutarBoton(value){
    
    switch(Number(value)){
      case 1:
        console.log('OPCION1');
        this.horario = "F1";
        this.estilo= "text-primary";
        this.estiloBtn="btn-primary";
        this.estadoHorario = "INGRESO";
        break;
      case 2:
        console.log('OPCION2');
        this.horario = "F2";
        this.estilo= "text-danger";
        this.estiloBtn="btn-danger";
        this.estadoHorario = "BREAK-IN";
        break;
      case 3:
        console.log('OPCION3');
        this.horario = "F3";
        this.estilo= "text-success";
        this.estiloBtn="btn-success";
        this.estadoHorario = "BREAK-OUT";
        break;
      case 4:
        console.log('OPCION4');
        this.horario = "F4";
        this.estilo= "text-warning";
        this.estiloBtn="btn-warning";
        this.estadoHorario = "SALIDA";
        break;
      case 5:
        console.log('OPCION5');
        this.horario = "ACCESO";
        this.estilo= "text-dark";
        this.estiloBtn="btn-dark";
        this.estadoHorario = "";
        break;      
    }
  }

  checking(){
    let termCond = Number(this.formulario.get('termCond').value);
    this.check = document.getElementById("termsCond") as HTMLInputElement;
        if (termCond === 1) {
          this.check.checked = false;
          this.strTermCond = 'Si Acepto.';
          this.opcionTermCond = 'Si';
        } else if (termCond === 0) {
          this.check.checked = true;
          this.strTermCond = 'No Acepto.';
          this.opcionTermCond = 'No';
        }
  }
  checkAccionTerminos() {
    let termCond = Number(this.formulario.get('termCond').value);
    if (termCond === 1) {
      this.valueTermCond = 0;
      this.activated = false;
      this.strTermCond = 'No Acepto.';
      this.opcionTermCond = 'No';
      this.lastEstiloBtn = this.estiloBtn; 
      this.estiloBtn = "btn-success";
    } else if (termCond === 0) {
      this.valueTermCond = 1;
      this.activated = true;
      this.strTermCond = 'Si Acepto.';
      this.opcionTermCond = 'Si';
      this.estiloBtn = this.lastEstiloBtn;
    }
    this.formulario.get('termCond').setValue(this.valueTermCond);
  }


}
